import * as R from 'ramda';
import { localize } from 'shared/components/other';
import { NavMenuItem } from 'shared/components/layout/Header/components/NavMenu';
import { LocaleIdType } from '../../locales';

type AccessModel<T> = Record<string, T>;
export type TAccessModelValue = AccessModel<
  boolean | { items: AccessModel<boolean> } | { hasAccess: boolean; externalLink: string }
>;
export function toNavMenuItems<T extends Record<string, boolean | T>>(value: TAccessModelValue): NavMenuItem[] {
  return R.toPairs(value).reduce<NavMenuItem[]>((acc, [key, val]) => {
    const id = camelToKebabCase(key);
    const label = localize(`site.title.${id}` as LocaleIdType);
    if (val && typeof val === 'boolean') {
      return [...acc, { label, path: `/${id}` }];
    } else if (val && typeof val === 'object' && 'items' in val) {
      return [...acc, { label, items: toNavMenuItems(val.items) }];
    } else if (val && typeof val === 'object' && val.hasAccess) {
      return [...acc, { label, path: val.externalLink, isExternalLink: true }];
    }
    return acc;
  }, []);
}

function camelToKebabCase(value: string) {
  return value.replace(/([a-z])([A-Z])/, (substring, ...args) => {
    return `${args[0]}-${args[1].toLowerCase()}`;
  });
}
